import {EditorView} from '@codemirror/view';
import type {Extension} from '@codemirror/state';

export type EditorPasteEvent = {
  doc: string;
  insertedLength: number;
  componentId?: string;
};

type PasteListener = (event: EditorPasteEvent) => void;

const listeners = new Set<PasteListener>();

export function onEditorPaste(listener: PasteListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function emitEditorPaste(event: EditorPasteEvent): void {
  for (const listener of listeners) listener(event);
}

export const pasteDetectExtension: Extension = EditorView.updateListener.of(
  (update) => {
    if (!update.docChanged) return;
    if (listeners.size === 0) return;
    if (
      !update.transactions.some((transaction) =>
        transaction.isUserEvent('input.paste')
      )
    ) {
      return;
    }

    let insertedLength = 0;
    update.changes.iterChanges((_fromA, _toA, _fromB, _toB, inserted) => {
      insertedLength += inserted.length;
    });

    emitEditorPaste({
      doc: update.state.doc.toString(),
      insertedLength,
    });
  }
);
